"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const tagItemsGenerator = (type, branches, groups) => {
  const memberType = [{
    label: type,
    type: 'secondary'
  }];
  const memberBranches = branches.map(branch => ({
    label: branch,
    type: 'tertiary'
  }));

  // this is the final array
  let items = memberType;
  if (groups) {
    const memberGroups = groups.map(branch => ({
      label: branch,
      type: 'quinary'
    }));
    items = items.concat(memberGroups);
  }
  items = items.concat(memberBranches);
  return items;
};
var _default = exports.default = tagItemsGenerator;